/* =============================================================================
   Jumentinho — Amaris Farmácia de Manipulação
   JavaScript puro, sem dependências.
   A loja é totalmente funcional sem este arquivo: tudo aqui é aprimoramento.
   Cada rotina recebe uma raiz, porque o editor de tema recarrega seções
   isoladamente e dispara shopify:section:load com a seção nova.
   ========================================================================== */
(function () {
  'use strict';

  var reduzirMovimento = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ------------------------------------------------- 1. Rolagem suave */
  function alturaDoCabecalho() {
    var raiz = getComputedStyle(document.documentElement);
    return parseInt(raiz.getPropertyValue('--header-h'), 10) || 80;
  }

  function rolagemSuave(raiz) {
    raiz.querySelectorAll('a[data-scroll]').forEach(function (link) {
      link.addEventListener('click', function (evento) {
        var destino = link.getAttribute('href');
        if (!destino || destino.charAt(0) !== '#') return;

        var alvo = document.querySelector(destino);
        if (!alvo) return;

        evento.preventDefault();
        var topo = alvo.getBoundingClientRect().top + window.pageYOffset
                   - alturaDoCabecalho() - 12;

        window.scrollTo({
          top: topo,
          behavior: reduzirMovimento.matches ? 'auto' : 'smooth'
        });

        // o foco acompanha a rolagem, para quem navega por teclado
        alvo.setAttribute('tabindex', '-1');
        alvo.focus({ preventScroll: true });
      });
    });
  }

  /* --------------------------------------------- 2. Aparição ao rolar */
  function aparicaoAoRolar(raiz) {
    if (!('IntersectionObserver' in window) || reduzirMovimento.matches) return;

    var candidatos = raiz.querySelectorAll(
      '.what__content, .collage, .benefits__head, .benefits__text, ' +
      '.sheet__frame, .sheet__content, .cta__inner'
    );
    if (!candidatos.length) return;

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        entrada.target.classList.add('is-visible');
        observador.unobserve(entrada.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

    candidatos.forEach(function (elemento) {
      // a classe só entra via JS: sem script, nada fica invisível
      elemento.classList.add('reveal');
      observador.observe(elemento);
    });
  }

  /* -------------------- 3. Prioridade visual das fotos da colagem */
  function colagem(raiz) {
    raiz.querySelectorAll('[data-collage]').forEach(function (grupo) {
      var fotos = Array.prototype.slice.call(
        grupo.querySelectorAll('.collage__item')
      );

      function trazerParaFrente(foto) {
        fotos.forEach(function (outra) {
          outra.classList.toggle('is-front', outra === foto);
        });
      }

      fotos.forEach(function (foto) {
        // toque: a primeira interação traz a foto para frente
        foto.addEventListener('pointerenter', function () { trazerParaFrente(foto); });
        foto.addEventListener('focusin', function () { trazerParaFrente(foto); });
      });

      grupo.addEventListener('pointerleave', function () {
        fotos.forEach(function (foto) { foto.classList.remove('is-front'); });
      });
    });
  }

  /* ------------------------------ 4. Profundidade leve nas fotos */
  function profundidade(raiz) {
    var comTilt = raiz.querySelectorAll('[data-tilt]');
    if (!comTilt.length) return;
    if (!window.matchMedia('(hover: hover)').matches) return;
    if (reduzirMovimento.matches) return;

    comTilt.forEach(function (alvo) {
      var quadroPendente = false;
      var ultimoEvento = null;

      function aplicar() {
        quadroPendente = false;
        if (!ultimoEvento) return;

        var caixa = alvo.getBoundingClientRect();
        var dx = (ultimoEvento.clientX - caixa.left) / caixa.width - 0.5;
        var dy = (ultimoEvento.clientY - caixa.top) / caixa.height - 0.5;

        // deslocamento discreto: só transform, sem repaint de sombra
        alvo.style.transform =
          'translate(' + (dx * 10).toFixed(2) + 'px,' +
          (dy * 10).toFixed(2) + 'px) scale(1.05)';
      }

      alvo.addEventListener('pointermove', function (evento) {
        if (evento.pointerType !== 'mouse') return;
        ultimoEvento = evento;
        if (quadroPendente) return;
        quadroPendente = true;
        requestAnimationFrame(aplicar);
      });

      alvo.addEventListener('pointerleave', function () {
        ultimoEvento = null;
        // devolve a rotação original definida no CSS
        alvo.style.transform = '';
      });
    });
  }

  /* ------------------------------------- 5. Preço que segue a variante */
  function variantes(raiz) {
    raiz.querySelectorAll('.form-compra').forEach(function (formulario) {
      var radios = formulario.querySelectorAll('.opcao__radio');
      if (!radios.length) return;

      // o preço vive fora do <form>, no bloco que envolve os dois
      var caixa = formulario.closest('.produto__info') || formulario.parentNode;

      var valor = caixa.querySelector('[data-preco-valor]');
      var de = caixa.querySelector('[data-preco-de]');

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (valor && radio.dataset.preco) valor.textContent = radio.dataset.preco;

          if (de) {
            var precoDe = radio.dataset.precoDe;
            de.textContent = precoDe || '';
            de.hidden = !precoDe;
          }
        });
      });
    });
  }

  /* ------------------------------------------ 6. Galeria do produto */
  function galeria(raiz) {
    raiz.querySelectorAll('.galeria').forEach(function (grupo) {
      var principal = grupo.querySelector('.galeria__principal img');
      var miniaturas = grupo.querySelectorAll('[data-galeria-mini]');
      if (!principal || !miniaturas.length) return;

      miniaturas.forEach(function (botao) {
        botao.addEventListener('click', function () {
          // srcset sai junto: senão o navegador ignora o src novo
          principal.removeAttribute('srcset');
          principal.removeAttribute('sizes');
          principal.src = botao.dataset.src;

          miniaturas.forEach(function (outra) {
            outra.setAttribute('aria-current', String(outra === botao));
          });
        });
      });
    });
  }

  /* ------------------------------------- 7. Barra fixa de compra */
  function barraDeCompra() {
    var barra = document.querySelector('[data-barra-compra]');
    if (!barra) return;

    var gatilho = document.querySelector('[data-cta="hero"], [data-cta="produto"]');

    if (!gatilho || !('IntersectionObserver' in window)) {
      barra.hidden = false;
      return;
    }

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        // a barra só entra quando o botão principal já saiu da tela
        barra.hidden = entrada.isIntersecting;
      });
    }, { threshold: 0 });

    observador.observe(gatilho);
  }

  /* ------------------------------------------------------ 8. Partida */
  function iniciar(raiz) {
    var alvo = raiz || document;
    rolagemSuave(alvo);
    aparicaoAoRolar(alvo);
    colagem(alvo);
    profundidade(alvo);
    variantes(alvo);
    galeria(alvo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciar(document);
      barraDeCompra();
    });
  } else {
    iniciar(document);
    barraDeCompra();
  }

  // o editor de tema recarrega uma seção por vez
  document.addEventListener('shopify:section:load', function (evento) {
    iniciar(evento.target);
    barraDeCompra();
  });
})();
